import $x from '@/utils/$x';

/**
 * 查询订单列表
 * @param {*} params
 * @returns
 */
export async function getOrderList(params) {
  return $x.post('/v1/litta/order/list', params);
}

/**
 * 查询快递公司列表
 * @returns
 */
export async function queryExpressCompanyList() {
  return $x.post('/v1/litta/order/queryExpressCompanyList');
}

/**
 * 更新物流信息（发货/签收）
 * @param {*} params
 * @returns
 */
export async function updateLogistics(params) {
  return $x.post('/v1/litta/order/updateLogistics', params);
}

/**
 * 更新快递单号
 * @param {*} params
 * @returns
 */
export async function updateExpressInfo(params) {
  return $x.post('/v1/litta/order/updateExpressInfo', params);
}

/**
 * 订单退款
 * @param {*} params
 * @returns
 */
export async function orderRefund(params) {
  return $x.post('/v1/litta/order/refund', params);
}
/**
 * 订单退款申请
 * @param {*} params
 * @returns
 */
export async function orderApplyRefund(params) {
  return $x.post('/v1/litta/order/apply_refund', params);
}
/**
 * 查询订单详情
 * @param {*} params
 * @returns
 */
export async function getOrdersDetail(params) {
  return $x.post('/v1/litta/order/getOrdersDetail', params);
}

/**
 * 查询订单来源枚举列表
 *
 */
export async function getChannelList(params) {
  return $x.post('/v1/litta/channel/getList', params);
}

/**
 * 查询订单来源枚举列表
 *
 */
export async function getBuyChannelList(params) {
  return $x.post('/v1/litta/order/promotionTypeList', params);
}

/**
 * 获取订单分析结果
 * @param {string} orderNo - 订单号
 * @returns
 */
export async function getOrderAnalysisResult(params) {
  return $x.post('/v1/litta/order/successAnalysisResult', params);
}

/// 抖音导入接口
/**
 * 外部订单列表-查询
 *
 */
export async function getThirdOrder(params) {
  return $x.post('/v1/third/order/list', params);
}

/**
 * 第三方商品关联列表查询
 *
 */
export async function queryThirdGoodsList(params) {
  return $x.post('/littaThirdGoods/queryThirdGoodsList', params);
}

/**
 * 保存第三方关联
 *
 */
export async function saveThirdGoodsRelated(params) {
  return $x.post('/littaThirdGoods/saveThirdGoodsRelated', params);
}

/**
 * 删除关联
 *
 */
export async function deleteThirdGoodsRelated(params) {
  return $x.post('/littaThirdGoods/deleteThirdGoodsRelated', params);
}

/**
 * 手动发放权益
 *
 */
export async function manualIssue(params) {
  return $x.post('/v1/litta/rights/manual/issue', params);
}
/**
 * 查询课程类型
 *
 */
export async function exerciseClssList(params) {
  return $x.post('/v1/litta/order/exerciseClassList', params);
}

/// API直充
/**
 * 查询课程类型
 *
 */
export async function queryPromotionList(params) {
  return $x.post('/v1/litta/order/promotion/list', params);
}

/**
 * 保存课程类型
 *
 */
export async function promotionSave(params) {
  return $x.post('/v1/litta/order/promotion/save', params);
}

/**
 * 删除课程类型
 *
 */
export async function promotionDelete(params) {
  return $x.post('/v1/litta/order/promotion/delete', params);
}

/**
 * 查询订单兑换码
 *
 */
export async function redeems(params) {
  return $x.post('/v1/litta/order/redeems', params);
}

/**
 * 查询订单触达事件
 *
 */
export async function reachAction(params) {
  return $x.post('/litta/order/ai/list-by-order-no', params);
}

/**
 * 先用后付
 *
 */
export async function getAgreementInfo(params) {
  return $x.post('/renew/get-agreement-info', params);
}

/**
 * 查询订单营销活动
 *
 */
export async function getOrderActivityList(params) {
  return $x.post('/v1/litta/order/orderActivityList', params);
}
/**
 * 修改手机
 *
 */
export async function setNameAndTel(params) {
  return $x.post('/doudian/order/set-name-and-tel', params);
}
/**
 * 礼品卡订单详情
 *
 */
export async function giftOrderDetail(params) {
  return $x.post('/v1/litta/order/gift-order-detail', params);
}
/**
 * 是否进群
 *
 */
export async function userHasGroup(params) {
  return $x.post('/litta/order/ai/group', params);
}
/**
 * 用户自动续费
 *
 */
export async function userAgreementInfo(params) {
  return $x.post('/renew/user-agreement-info', params);
}
/**
 * 用户自动续费 解约
 *
 */
export async function userAgreementUnSign(params) {
  return $x.post('/renew/un-sign', params);
}

/**
 * 重发权益
 *
 */
export async function issueAndPostHandle(params) {
  return $x.post(
    `/doudian/third-order/rights/issue-and-post-handle?orderId=${params.orderId}`,
  );
}
